// extracted by mini-css-extract-plugin
export default {"Alert":"ghIS_py3","Icon":"VD6vkMad","isVisible":"vp1iUEy9","isClosing":"uOo3T9Y6","isMobile":"MI0pbQtP","Success":"bMaO7cfn","Error":"uNVysaG_"};